// Запуск: ABsmartly-аудитория country = US (копи и проценты скидок посчитаны под US).
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_relaxed_upsells~1
		female: {
			upsell: {
				experiment: {
					'upsell-f': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_relaxed_upsells~1
		male: {
			upsell: {
				experiment: {
					'upsell-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_relaxed_upsells~1
		'activity-female-walking': {
			upsell: {
				experiment: {
					'upsell-activity-f': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_relaxed_upsells~1
		'activity-male-walking': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_relaxed_upsells~1
		'activity-male-chair-tai-chi': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_relaxed_upsells~1
		'activity-male-chair-tai-chi-al': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-walking-al&exp=web_relaxed_upsells~1
		'activity-male-tai-chi-walking-al': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_relaxed_upsells~1
		'activity-male-tai-chi-yoga-al': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_relaxed_upsells~1
		'activity-male-tai-chi-yoga-pr': {
			upsell: {
				experiment: {
					'upsell-activity-m': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// Эта воронка под country: 'us' подменяет инстанс на upsell-yoga-m-us
		// (areas/yoga/activity-male-chair-workouts.ts) — ключуем его, а не upsell-yoga-m.
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_relaxed_upsells~1
		'activity-male-chair-workouts': {
			upsell: {
				experiment: {
					'upsell-yoga-m-us': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_relaxed_upsells~1
		'activity-female-tai-chi-walking-pr': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_relaxed_upsells~1
		'activity-female-tai-chi-walking-v2': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_relaxed_upsells~1
		'activity-female-tai-chi-walking-v2-al': {
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity'),
				},
			},
		},
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_relaxed_upsells~1
		'activity-female-yoga': {
			upsell: {
				experiment: {
					'upsell-yoga-f': () => import('@/modules/Upsell/instances/experiments/web_relaxed_upsells__activity_yoga_f'),
				},
			},
		},
	},
]

export default config
